(function () {
  'use strict';

  function init(scope) {
    scope.querySelectorAll('.carderia-category-trigger').forEach(function (trigger) {
      if (trigger.dataset.drawerReady === 'true') return;
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || !dialog.showModal) return;
      trigger.dataset.drawerReady = 'true';
      const closeButton = dialog.querySelector('[data-carderia-category-close]');
      let closeTimer;

      function close() {
        if (!dialog.open) return;
        dialog.classList.remove('is-open');
        window.clearTimeout(closeTimer);
        const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
        closeTimer = window.setTimeout(function () {
          dialog.close();
          trigger.focus({ preventScroll: true });
        }, delay);
      }

      trigger.addEventListener('click', function () {
        window.clearTimeout(closeTimer);
        dialog.showModal();
        window.requestAnimationFrame(function () { dialog.classList.add('is-open'); });
        closeButton.focus({ preventScroll: true });
      });
      closeButton.addEventListener('click', close);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && event.clientX > dialog.getBoundingClientRect().right) close();
      });
      dialog.addEventListener('cancel', function () { dialog.classList.remove('is-open'); });
      dialog.addEventListener('close', function () { dialog.classList.remove('is-open'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
